import type { InferRouterInputs, InferRouterOutputs } from '@orpc/server';
import { type AppRouter } from 'server/api/root';

function getBaseUrl() {
  if (typeof window !== 'undefined') {
    return location.origin;
  }
  return `https://app.quotion.co`;
}

export function getUrl(pathPrefix = '') {
  return `${getBaseUrl()}${pathPrefix}/api/rpc`;
}

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = InferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = InferRouterOutputs<AppRouter>;
